import { NgModule } from '@angular/core';
import { ColorPickerModule } from 'ngx-color-picker';

import { BackendRoutingModule } from './backend-routing.module';
import { PlantingSiteDetailsComponent } from './planting-site-details/planting-site-details.component';
import { CoreModule } from '../core/core.module';
import { PhotoUploadComponent } from './photo-upload/photo-upload.component';
import { DragDropDirective } from './photo-upload/drag-drop.directive';
import { PlantingSiteListComponent } from './planting-site-list/planting-site-list.component';
import { BackendComponent } from './backend.component';
import { CustomersComponent } from './customers/customers.component';
import { SiteTableComponent } from './planting-site-list/site-table.component';

import { PlantedTreesComponent } from './planting-site-details/planted-trees/planted-trees.component';
import { CertificatesComponent } from './planting-site-details/certificates/certificates.component';
import { DocumentationComponent } from './planting-site-details/documentation/documentation.component';
import { GeneralInformationComponent } from './planting-site-details/general-information/general-information.component';
import { AreasComponent } from './planting-site-details/areas/areas.component';
import { AreasRowComponent } from './planting-site-details/areas/areas-row/areas-row.component';
import { VideosComponent } from './planting-site-details/videos/videos.component';
import { VideosRowComponent } from './planting-site-details/videos/videos-row/videos-row.component';
import { AreasEntryComponent } from './planting-site-details/areas/areas-entry/areas-entry.component';
import { PhotosListComponent } from './planting-site-details/documentation/photos-list.component';
import { IsCollectionThumbnailPipe } from './planting-site-details/documentation/is-collection-thumbnail.pipe';
import { UploadWizardComponent } from './planting-site-details/documentation/upload-wizard.component';
import { ReactiveFormsModule   } from '@angular/forms';
import { PhotoEditorComponent } from './planting-site-details/documentation/photo-editor/photo-editor.component';
import { PlantedTreesRowComponent } from './planting-site-details/planted-trees/planted-trees-row/planted-trees-row.component';
import { CustomerDetailsComponent } from './customers/customer-details/customer-details.component';
import { CollectionRowComponent } from './planting-site-details/documentation/collection-row/collection-row.component';
import { LoginComponent } from '../accounts/components/login/login.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { AlertModule } from 'ngx-bootstrap/alert';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { CertificatesRowComponent } from './planting-site-details/certificates/certificates-row/certificates-row.component';
import { CreateCustomerModalComponent } from './planting-site-details/certificates/create-customer-modal/create-customer-modal.component';

import { PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarModule, PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { DuplicateNameConfirmModalComponent } from './customers/customer-details/duplicate-name-confirm-modal/duplicate-name-confirm-modal.component';
import { ModalGeneralInformationComponent } from './planting-site-details/general-information/modal-general-information/modal-general-information/modal-general-information.component';
import { UsersComponent } from './users/users.component';
import { UserDetailsComponent } from './users/user-details/user-details.component';
import { ModalPlantedTreesComponent } from './planting-site-details/modal-planted-trees/modal-planted-trees/modal-planted-trees.component';
import { TreeSpeciesComponent } from './tree-species/tree-species.component';
import { ModalAddTreeSpeciesComponent } from './tree-species/modals/add-tree-species.component';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    suppressScrollX: true
};


@NgModule({
    declarations: [
        PlantingSiteDetailsComponent,
        PhotoUploadComponent,
        DragDropDirective,
        PlantingSiteListComponent,
        BackendComponent,
        CustomersComponent,
        SiteTableComponent,
        PlantedTreesComponent,
        CertificatesComponent,
        DocumentationComponent,
        GeneralInformationComponent,
        PhotosListComponent,
        IsCollectionThumbnailPipe,
        UploadWizardComponent,
        PlantedTreesRowComponent,
        CustomerDetailsComponent,
        PhotoEditorComponent,
        CollectionRowComponent,
        CertificatesRowComponent,
        LoginComponent,
        CreateCustomerModalComponent,
        DuplicateNameConfirmModalComponent,
        ModalGeneralInformationComponent,
        AreasComponent,
        AreasRowComponent,
        AreasEntryComponent,
        UsersComponent,
        UserDetailsComponent,
        VideosComponent,
        VideosRowComponent,
        ModalPlantedTreesComponent,
        TreeSpeciesComponent,
        ModalAddTreeSpeciesComponent
    ],
    imports: [
        CoreModule,
        ColorPickerModule,
        PerfectScrollbarModule,
        BackendRoutingModule,
        ReactiveFormsModule,
        ModalModule.forRoot(),
        TabsModule.forRoot(),
        AlertModule.forRoot(),
        TypeaheadModule.forRoot(),
        ButtonsModule.forRoot()
    ],
    providers: [
        {
            provide: PERFECT_SCROLLBAR_CONFIG,
            useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
        }
    ],
    entryComponents: [
        ModalGeneralInformationComponent,
        ModalPlantedTreesComponent,
        ModalAddTreeSpeciesComponent
     ]

})
export class BackendModule {}
